// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 995) return "static/chunks/995-a65f70681f2b29ca.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"774":"c7001e45","970":"af3b0a73"}[chunkId] || chunkId) + "." + {"774":"d61ed03c6c562c09","800":"d9a796a8a7a90d7b","933":"64333913b127ef35","954":"a28597488277c4f7","970":"a1712c8b964c6d7e","996":"55acc1c89c3e0fe7"}[chunkId] + ".js";
};